import { Switch, Route, Link } from 'react-router-dom';

function Header (props) {

    const { user } = props;

    return (<div className="mc-hero">
        <div className="uk-container">
                    
            {user ? 
                <Switch>
                    <Route path='/profile'>
                        <h2 className="uk-animation-fade">
                            Profil
                            <Link to="/" className="mc-retour">&lt; Retour</Link>
                        </h2>
                        
                    </Route>
                    <Route path='/'>
                        <h2 className="uk-animation-fade">
                            Bonjour <span id="user-name">{user.displayName}</span> !
                        </h2>
                    </Route>
                </Switch> : <Switch>
                    <Route path='/forgot-password'>
                        <h2 className="uk-animation-fade">
                            Mot de passe oublié
                            <Link to="/" className="mc-retour">&lt; Retour</Link>
                        </h2>
                    </Route>
                    <Route path='/'>
                        <h2 className="uk-animation-fade uk-container-connexion">Connexion</h2>
                    </Route>
                </Switch>}
        </div>
    </div>);
}

export default Header;
